'use client';

import { useEffect, useState } from 'react';

/**
 * Hook to detect when client-side hydration is complete.
 * Returns an object with hydrated status and a suspense key for preventing hydration mismatches.
 * Useful for safely showing different content on server vs client by triggering a remount after hydration.
 */
export function useHydration(): { hydrated: boolean; suspenseKey: string } {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  return {
    hydrated,
    suspenseKey: hydrated ? 'client' : 'server',
  };
}
